module.exports = __webpack_public_path__ + "img/GALLERY-VITARA-6.9e2553e6.jpg";